import React from 'react';

import NotificationItem from './_notificationItem';
import { NotificationVendorWithCustomer } from '@models/notifications.model';

interface Props {
  notification: NotificationVendorWithCustomer;
  onNavigate: () => void;
}

const NotificationVendorRefundRequest: React.FC<Props> = ({ notification }) => {
  const CSSBlock = 'notification-refund-request';
  // const navigate = useNavigate();
  // const dispatch = useAppDispatch();

  const onClickView = () => {
    // navigateTransitioned({
    //   dispatch,
    //   navigate,
    //   to: routingPaths[RoutingViews.ORDERS_ALL],
    //   search: {
    //     [SearchParams.ORDER_ID]: notification.orderDocID!,
    //     [SearchParams.ACTIVE_TAB]: OrdersPageTabs.REFUND_STATUS,
    //   },
    // });
    // onNavigate();
  };

  return (
    <NotificationItem
      notification={notification}
      CSSBlock={CSSBlock}
      buttonText="View"
      buttonOnClick={onClickView}></NotificationItem>
  );
};

export default NotificationVendorRefundRequest;
